// modules
import { RForm } from '@/components/reusable_components/next'
import AccAccountingSeatConceptService from '@/services/api/accounting/AccAccountingSeatConcept'
import TranslatorService from '@/services/translator'

// partials
import AccAccountingSeatConceptFields from "@/views/Accounting/AccAccountingSeatConcept/fields"

// components
export default {
  components: {
    RForm,
  },
  computed: {

    /**
     * 
     */
    formProps() {
      return {
        fields: AccAccountingSeatConceptFields.toUpdate(),
      }
    }
  },
  data() {
    return {
      accAccountingSeatConcept: {
        
      },
    }
  },
  methods: {

    /**
     * 
     */
    onError(error) {
      this.showErrorSnackbar(TranslatorService(AccAccountingSeatConceptService.model(), error.response.data))
    },
    
    /**
     * 
     */
    onReset() {
      this.$refs.form.setWait(true).then(this.refresh).then(this.$refs.form.setWait)
    },
    
    /**
     * 
     */
    onSubmit() {
      this.$refs.form.setWait(true).then(this.update).then(this.$refs.form.setWait)
    },

    /**
     * 
     */
    onSuccess() {
      this.showSuccessSnackbar('Concepto actualizado exitosamente.')
    },

    /**
     * 
     */
    refresh() {
      return AccAccountingSeatConceptService.model().find(this.$route.params.id).then(accAccountingSeatConcept => {
        this.accAccountingSeatConcept = accAccountingSeatConcept
      })
    },

    /**
     * 
     */
    update() {
      return AccAccountingSeatConceptService.update(this.accAccountingSeatConcept).then(this.onSuccess).catch(this.onError)
    },
  },
  mounted() {
    this.setTitle('Detalles de concepto')
    this.onReset()
  }
}